import React from 'react'
import { useOutletContext } from 'react-router-dom'
import type { HistoryOutletContext } from './ModernHistoryLayout'
import HistoryWalletReport from './HistoryWalletReport'

/** หน้า ประวัติการรับเครดิต */
const HistoryCreditPage: React.FC = () => {
  useOutletContext<HistoryOutletContext>()
  return <HistoryWalletReport mode="credit" />
}

export default HistoryCreditPage
